import React from 'react'

export default function LoadingMessage(props) {
    return(
        <p className="loading-message">
            <span className="fas fa-film film-logo"></span>
            Loading...
        </p>
    )
}